// extracted by mini-css-extract-plugin
module.exports = {"favorite":"Favorite_favorite__2JpJm","not-found":"Favorite_not-found__3BaKg","actions":"Favorite_actions__2Q5rH"};